import { IdCodeLibelle } from '../../id-code-libelle.abstract.model';

export class DroitRole extends IdCodeLibelle {}
